"use client";

import React from "react";
import { StyledDiv } from "./trustedBy.styles";
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';
import classNames from "classnames";

export const TrustedBy = ({ mode = 'light' }: { mode?: 'light' | 'dark'; }) => {
  return (
    <StyledDiv className={classNames(mode)}>
      <h3>Trusted by</h3>
      <CommonNinjaWidgetRenderer widgetId="9dead464-d1a6-4537-9c2c-41629ed375dc" />
    </StyledDiv>
  );
};
